import {
  FINANCE_PACKAGES_BATCH_DELETE_REQUEST,
  FINANCE_PACKAGES_BATCH_DELETE_SUCCESS,
  FINANCE_PACKAGES_BATCH_DELETE_FAILURE,
  FINANCE_PACKAGES_FETCH_MANY_REQUEST,
  FINANCE_PACKAGES_FETCH_MANY_SUCCESS,
  FINANCE_PACKAGES_FETCH_MANY_FAILURE,
  FINANCE_PACKAGES_FETCH_REQUEST,
  FINANCE_PACKAGES_FETCH_SUCCESS,
  FINANCE_PACKAGES_FETCH_FAILURE,
  FINANCE_PACKAGES_SAVE_REQUEST,
  FINANCE_PACKAGES_SAVE_SUCCESS,
  FINANCE_PACKAGES_SAVE_FAILURE,

  EMPTY_FINANCE_PACKAGES,
  CLEAR_ERRORS
} from './types'

export default {
  deleteMany ({ commit }, { ids = [] }) {
    commit(FINANCE_PACKAGES_BATCH_DELETE_REQUEST)
    return window.axios.post('/finance-packages', { _method: 'DELETE', ids }).then(response => {
      commit(FINANCE_PACKAGES_BATCH_DELETE_SUCCESS, response)
      return response
    }).catch(error => {
      commit(FINANCE_PACKAGES_BATCH_DELETE_FAILURE, error)
      throw error
    })
  },
  fetchMany ({ commit }, { query = '', page = 1 }) {
    commit(FINANCE_PACKAGES_FETCH_MANY_REQUEST)
    return window.axios.get('/finance-packages', { params: { query, page } }).then(response => {
      commit(FINANCE_PACKAGES_FETCH_MANY_SUCCESS, response)
      return response
    }).catch(error => {
      commit(FINANCE_PACKAGES_FETCH_MANY_FAILURE, error)
      throw error
    })
  },
  fetch ({ commit }, id) {
    commit(FINANCE_PACKAGES_FETCH_REQUEST)
    return window.axios.get(`/finance-packages/${id}`).then(response => {
      commit(FINANCE_PACKAGES_FETCH_SUCCESS, response)
      return response
    }).catch(error => {
      commit(FINANCE_PACKAGES_FETCH_FAILURE, error)
      throw error
    })
  },
  save ({ commit }, financePackage) {
    const path = financePackage.id ? `/finance-packages/${financePackage.id}` : '/finance-packages'
    const method = financePackage.id ? 'put' : 'post'

    commit(FINANCE_PACKAGES_SAVE_REQUEST)
    return window.axios[method](path, financePackage).then(response => {
      commit(FINANCE_PACKAGES_SAVE_SUCCESS, response)
      return response
    }).catch(error => {
      if (error.response.status === 422) {
        commit(FINANCE_PACKAGES_SAVE_FAILURE, { validationErrors: error.response.data })
      } else {
        commit(FINANCE_PACKAGES_SAVE_FAILURE, { error })
      }
      throw error
    })
  },
  empty({ commit }) {
    commit(EMPTY_FINANCE_PACKAGES);
  },
  clearErrors({ commit }) {
    commit(CLEAR_ERRORS)
  }
}
